import React, { useEffect } from 'react';
import { Modal } from '../modal';
import { Flex, Button } from '@mantine/core';
import { ReactComponent as Success } from './success.svg';
import { useIntl } from 'react-intl';
import { theme } from '../globalStyle/global-styles';
import { useNavigate } from 'react-router-dom';
import { DeleteButtonContainer } from './styles';

interface SuccessModalProps {
  showSuccessModal: boolean;
  setShowSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  message: string;
  navigateTo?: string;
}

export function SuccessModal({
  showSuccessModal,
  setShowSuccessModal,
  message,
  navigateTo = '',
}: SuccessModalProps) {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  return (
    <Modal
      opened={showSuccessModal}
      size="xs"
      onClose={() => {
        navigate(navigateTo);
        setShowSuccessModal(false);
      }}
      withCloseButton={false}
      padding="56px 0"
      className="success-modal"
      closeOnEscape={false}
    >
      <Flex justify={'center'} align={'center'} direction={'column'} gap={32}>
        <Success />
        <p
          style={{
            fontSize: '16px',
            fontWeight: '600',
            fontFamily: `${theme.fonts.Regular}`,
            textAlign: 'center',
          }}
        >
          {formatMessage({ id: `${message}` })}
        </p>
        <DeleteButtonContainer>
          <Button
            type="reset"
            onClick={() => {
              setShowSuccessModal(false);
              navigate(navigateTo);
            }}
          >
            {formatMessage({ id: 'ok' })}
          </Button>
        </DeleteButtonContainer>
      </Flex>
    </Modal>
  );
}
